// CSS
import "./styles/global.scss";

//JS
import "../modernizr.js";
